import { PoliceSideService } from "../_services/police.side.actions";

export const PoliceSideActions = {
  PoliceSideCommonSearch,
  getResidentsByPoliceStationSearchByPolice,
  getCriminalsByPoliceStationAreaSearchByPolice,
  getResidentsByPoliceStationIdSearchByPolice,
  PoliceSideSnapShots,
  PoliceSideGraphSnapShots,
  getAccusedListWithTwoOrMoreCount,
  getAccusedListWithTwoOrMoreByIdCount,
  dailyReports,
  getCctnsMapDistrict,
  getGunaCctnsData,
  getArestCctnsData,
};
function PoliceSideCommonSearch(values) {
  return PoliceSideService.PoliceSideCommonSearch(values);
}
function getResidentsByPoliceStationSearchByPolice(values) {
  return PoliceSideService.getResidentsByPoliceStationSearchByPolice(values);
}
function getCriminalsByPoliceStationAreaSearchByPolice(values) {
  return PoliceSideService.getCriminalsByPoliceStationAreaSearchByPolice(
    values,
  );
}
function getResidentsByPoliceStationIdSearchByPolice(values) {
  return PoliceSideService.getResidentsByPoliceStationIdSearchByPolice(values);
}
function PoliceSideSnapShots(values) {
  return PoliceSideService.PoliceSideSnapShots(values);
}
function PoliceSideGraphSnapShots(values) {
  return PoliceSideService.PoliceSideGraphSnapShots(values);
}
function getAccusedListWithTwoOrMoreCount(values) {
  return PoliceSideService.getAccusedListWithTwoOrMoreCount(values);
}
function getAccusedListWithTwoOrMoreByIdCount(values) {
  return PoliceSideService.getAccusedListWithTwoOrMoreByIdCount(values);
}
function dailyReports(values) {
  return PoliceSideService.dailyReports(values);
}
function getCctnsMapDistrict(id) {
  return PoliceSideService.getCctnsMapDistrict(id);
}
function getGunaCctnsData(values) {
  return PoliceSideService.getGunaCctnsData(values);
}
function getArestCctnsData(values) {
  return PoliceSideService.getArestCctnsData(values);
}
